module.exports = __webpack_public_path__ + "img/2-kilo-blue.bd270094.svg";